/**
 * Notification Preferences API Module - Issue #319
 * 
 * API functions for user notification preferences
 */

import { apiGet, apiPatch } from '../api';

export interface NotificationPreferences {
  user_id: string;
  email_invites: boolean;
  email_event_reminders: boolean;
  email_rsvp_confirmations: boolean;
  email_event_updates: boolean;
  email_club_updates: boolean;
  email_digest: boolean;
  sms_enabled: boolean;
  push_enabled: boolean;
  updated_at: number;
}

export interface UpdateNotificationPreferencesRequest {
  email_invites?: boolean;
  email_event_reminders?: boolean;
  email_rsvp_confirmations?: boolean;
  email_event_updates?: boolean;
  email_club_updates?: boolean;
  email_digest?: boolean;
  sms_enabled?: boolean;
  push_enabled?: boolean;
}

export interface NotificationPreferencesResponse {
  preferences: NotificationPreferences;
}

/**
 * Notification Preferences API functions
 */
export const notificationsApi = {
  /**
   * Get user's notification preferences
   */
  getPreferences: (): Promise<NotificationPreferencesResponse> => {
    return apiGet<NotificationPreferencesResponse>('/users/preferences/notifications');
  },

  /**
   * Update user's notification preferences
   */
  updatePreferences: (data: UpdateNotificationPreferencesRequest): Promise<NotificationPreferencesResponse> => {
    return apiPatch<NotificationPreferencesResponse>('/users/preferences/notifications', data);
  },
};